import logo from './Images/prime-logo.png'
import HP from './Images/HPlogo.png'
import IMDB from './Images/IMDB_Logo.png'



const Header = () => {
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12 p-0 m-0">
                    <nav className="navbar navbar-expand-lg navbg pt-2 ps-2 pe-5 fixed-top  ">
                        <div className="container-fluid">
                            {/* <Link className="navbar-brand text-white fs-1 font1" to="#">Feane</Link> */}
                            <img src={logo} className='logo'></img>
                            <button className="navbar-toggler bg-light" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon"></span>
                            </button>
                            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                <ul className="navbar-nav mx-auto mb-2 mb-lg-0 ps-5">
                                    <li className="nav-item">
                                        <a className="nav-link active px-4 text-white home font2 fw-bold fs-5" aria-current="page" to="./">Home</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link active px-4 text-white menu font2 fw-bold fs-5" aria-current="page" to="./">Store</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link active px-4 text-white about font2 fw-bold fs-5" aria-current="page" to="./">Live TV</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link active px-4 text-white book font2 fw-bold fs-5" aria-current="page" to="./">Categories</a>
                                    </li>




                                </ul>
                                <div className="pe-5">
                                    <i class="fas fa-search text-white pe-5 fs-5"></i><i class="fas fa-user text-white pe-4 fs-5"></i>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>

            <div className="row pb-5 mt-5" id="Hero">
                <div className="col-12 col-md-7 col-lg-7" >
                    <div className="Content" >
                        <img src={HP} className='HPlogo'></img>
                        <p className="text-white font2 fw-bold DN">Based on the wildly popular J.K. Rowling's book about a young boy who on his eleventh birthday discovers, he is the orphaned boy of two powerful wizards and has unique magical powers.The main story arc concerns Harry's conflict with Lord Voldemort, a dark wizard who intends to become immortal.</p>
                        <h6 className='text-white fw-bold fs-5 ' >U/A 16+ | UHD</h6>
                        <h6 className='text-white fw-bold fs-5 pt-1 ' >Suspense | Adventure | Dark | Fantasy</h6>
                        <img src={IMDB} className='imdb pb-1'></img><a className='text-light text-decoration-none fw-bold fs-5 ps-1 pt-3'><i class="fas fa-star text-warning pe-1"></i>8.2</a>
                        <h6 className='text-white fw-bold fs-5 pt-2' ><i class="fas fa-check-circle text-info pe-2"></i>Watch with a free Prime trial</h6>
                        
                        <div>
                        <button type="button" className="font1 fs-5 fw-bold btn btn-light  text-dark rounded py-2 mt-2 me-3">Rent Rs.279</button>   
                        <button type="button" className="font1 fs-5 fw-bold btn btn-light  text-dark  rounded py-2 mt-2 me-3">More Purchase Options</button> 
                        <button type="button" className="font1 fs-5 fw-bold btn btn-light  text-dark  rounded mt-2"><i class="fas fa-film text-dark fs-2 "></i></button>
                        <button type="button" className="font1 fs-5 fw-bold btn btn-light  text-dark  rounded mt-2 ms-3"><i class="fas fa-plus text-dark fs-2"></i></button>
                        <button type="button" className="font1 fs-5 fw-bold btn btn-light  text-dark  rounded mt-2 ms-3"><i class="fas fa-share-alt text-dark fs-2"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}
export default Header;